import { render, staticRenderFns } from "./TargetTrainingHoursNew.vue?vue&type=template&id=b6fb6932"
import script from "./TargetTrainingHoursNew.vue?vue&type=script&lang=js"
export * from "./TargetTrainingHoursNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports